import { Component, Prop, Watch } from 'vue-property-decorator';
import { Route } from 'vue-router';
import Vue from 'vue';

import { getSliderImages  } from '../../util';

import WithRender from './profile.tpl.html';
import { Performer, PerformerAvatar } from 'sensejs/performer/performer.model';
import { getByAdvert } from 'sensejs/performer';
import { createPhoneReservation } from 'sensejs/session';
import { setTitle, setDescription, setKeywords } from '../../seo';
import Carousel from './carousel/carousel';

import config, { content } from '../../config';

@WithRender
@Component({
    components: {
        carousel: Carousel
    }
})
export default class Profile extends Vue {

    cost = config.Phonecost;
    performer: Performer | null = null;
    perfmedia: PerformerAvatar[] | null = null;
    currentSliderSelected:number = 0;
    content = content;

    getSliderImages = getSliderImages;

    get safeMode(){
        return this.$store.getters.getSafeMode;
    }

    mounted(){
        this.loadPerformer(parseInt(this.$route.params.id));
    }
    
    navigateSlides(target: string, index: number){
        window.scrollTo(0, 0);
        if(!this.perfmedia){ return }
        if(target === 'next' && !(this.currentSliderSelected === this.perfmedia.length - 1)){
            this.currentSliderSelected += 1;
        } else if(target === 'previous' && (this.currentSliderSelected != 0)){
            this.currentSliderSelected -= 1;
        } else if (target === 'select'){
            this.currentSliderSelected = index;
        } else {
            return;
        }
    }

    breastSize(cupSize:string):string{
        const knownSizes = ['xsmall', 'small', 'medium', 'large', 'xlarge'];
        if (knownSizes.indexOf(cupSize) == -1){
            return cupSize;

        }

        return this.$t(`profile.breastsizes.${cupSize}`).toString();
    }

    eyeColor(color:string):string{
        if (color === 'red&violet'){ color = 'redviolet'; }
        const knownColors = ['brown','hazel','blue','green','silver','amber','grey','redviolet'];
        if (knownColors.indexOf(color) == -1){
            return color;
        }

        return this.$t(`profile.eyecolors.${color}`).toString();
    }

    async loadPerformer(id: number){
        const { result, error } = await getByAdvert(id);

        if(error){
            this.$router.push({ name: 'Performers' });

            throw new Error(`Api error: ${error}`);
        }

        this.performer = result;

        if(!result.photos) { return; }
        if(!result.photos.approved) { return; }
        if(this.safeMode){
            this.perfmedia = [];
            for (const photo of result.photos.approved.photos) {
                const pushfoto = photo.safe_version ? this.perfmedia.push(photo) : '';
            }
        } else {
            this.perfmedia = result.photos.approved.photos;
        }

        this.perfmedia = this.perfmedia.slice(0, 4);

        if(content.meta && content.meta.profiletitle){
            const metatitle = content.meta.profiletitle ? setTitle(content.meta.profiletitle.replace("{nickname}", this.performer.nickname)) : '';
            const metadesc = content.meta.profiledesc ? setDescription(content.meta.profiledesc.replace("{nickname}", this.performer.nickname)) : '';
        }
        setKeywords(`${this.performer.nickname}, ${this.performer.eyeColor}, ${this.performer.cupSize}`);
    }

    async startCall(){
        if(!this.performer){
            return;
        }

        console.log('doet iets?');

        const { result, error } = await createPhoneReservation(this.performer.advertId);

        if(error){
            return;
        }

        if(result.DNIS){
            window.open(`tel:${result.DNIS}`, '_self');
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/pages/profile.ts